import { useState } from 'react'
import Modal from '../../../../shared/Modal'
import AudioDropzone from '../../../../shared/Dropzone/AudioDropzone'
import Button from '../../../../shared/Buttons/Button'
import { IDraftAudio } from '../../../../types/tasks.types'
import Checkbox from '../../../../shared/Checkbox'

interface IProps {
  onClose: () => void
  onCreate: (audio: IDraftAudio) => void
}

const CreateAudioOptionModal = (props: IProps) => {
  const [file, setFile] = useState<File>(null)
  const [right, setRight] = useState(false)

  const renderFileInfo = () => {
    if (!file) return null

    return (
      <div style={{ marginBottom: '1em' }}>
        <span style={{ fontSize: '32px' }}>{file.name}</span>
      </div>
    )
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        {renderFileInfo()}
        <AudioDropzone onFile={setFile} hasFile={Boolean(file)} />
        <Checkbox checked={right} onChange={setRight} inscription="Правильный ответ" name="right" />
        <div className="form-footer">
          {file && (
            <Button onClick={() => props.onCreate({ file, rightAnswer: right, type: 'ANSWER_OPTION' })}>
              Сохранить
            </Button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default CreateAudioOptionModal
